<template>
  <v-main style="height: 100%">
    <v-container fluid class="justify-center align-center fill-height gradientBackground">
      <v-snackbar
          v-model="showMessage"
          vertical
          bottom
          center
          :color="messageColor"
      >
        <p class="mb-0">{{ message }}</p>
      </v-snackbar>

        <v-row class="justify-center" :class="{'datos-personales': this.step == 2 }">                                      
        <v-col cols="1" md="2" lg="3" class="ma-0 pa-0 d-flex justify-end align-start mt-10 pt-10 ">
          <v-btn
              height="80"
              elevation="4"
              tile
              color="grey darken-1"
              class="white--text d-none d-md-flex"
              style="border-radius: 10px 0 0 10px"
              @click="subsStep()"
              v-if="step > 1"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="10" md="8" lg="6" class="ma-0 pa-0">
      
          <v-card class="elevation-12 rounded-xl" :class="{'card-reserva': this.step == 5}" style="margin-top: 20px;margin-bottom: 20px;">
            <v-row class="justify-center ">
<!--         <img style="opacity:1; margin-top: 20px;" src="../../assets/cat.svg"  alt="" width="100" /> -->
<h5 style="margin-top: 20px;">TRÁMITES DE LICENCIA DE CONDUCIR</h5>
      </v-row>    
            <v-card-title class="justify-start align-center ma-2">
              <v-icon
                  color="blue"
                  size="40"
                  class="d-none d-md-flex"
              >
                {{ switchIcon() }}
              </v-icon>
              <v-btn
              height="65"
              elevation="0"
              color="transparent"
              class="primary--text d-md-none"
              style="border-radius: 50px;"
              @click="subsStep()"
              v-if="step > 1">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
              <h3 class=" ma-2 mx-4 card-title">
                {{ switchTitle() }}
              </h3>
            </v-card-title>

              
            <v-card-text class="justify-center align-center">
                <!--              step 1, ingresar rut-->
<!--                 <v-row class="justify-center align-center" v-if="step === 1">
                  <v-col cols="12" sm="8" md="6" class="justify-center align-center d-flex flex-column">
                    <v-col cols="12" sm="12" md="12" class="justify-center align-center d-flex">

                      <v-text-field
                          v-model="patient.rut"
                          :rules="rutRules"
                          label="Ingrese su rut"
                          required
                          dense
                          clearable
                          @keyup="(rut) => {formatRut(patient.rut)}"
                          v-if="step === 1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="8" md="6" class="justify-center align-center d-flex">
                      <v-btn
                          color="primary"
                          class="white--text"
                          @click="searchRut"
                          outlined
                          rounded
                          :disabled="loading || !validRut"
                      >
                        Reservar
                      </v-btn>
                    </v-col>
                  </v-col>
                </v-row> -->
                
                <!-- Step 3 - Formularios -->
                <v-row class="justify-center align-center" v-if="step === 3">
                  <v-col cols="12" sm="12" md="12" class="justify-center align-center d-flex flex-row flex-wrap py-0">
          <v-form ref="form" v-model="valid" style="width: 100%;">
            <v-row class="pa-8" dense>

					<!-- campos específicos -->
            <v-col cols="12">
						<div v-for="(field, i) in formFields" :key="field.id">
							<!-- text -->
							<v-text-field
                class="mt-4"
								v-if="field.input_type_id == 1"
								v-model="formData[field.id]"
								:label="field.name_field"
								:rules="field.required_field ? required : ''"
								variant="outlined"
                :hint="field.description" persistent-hint
              ></v-text-field>
              <!-- email -->
							<v-text-field
                class="mt-4"
								v-if="field.input_type_id == 2"
								v-model="formData[field.id]"
								:label="field.name_field"
                :rules="isEmailValid"
                @change="(email) => {isEmail(email)}"
								variant="outlined"
                :hint="field.description" persistent-hint
              ></v-text-field>
              <!-- rut -->
              <v-text-field
                class="mt-4"
                v-if="field.input_type_id == 3"
                v-model="formData[field.id]"
						    :rules="rut"
                :label="field.name_field"
                variant="outlined"
						    @keyup="(rut) => {formatRutD(formData[field.id], field.id)}"
                :hint="field.description" persistent-hint
              ></v-text-field>
              <!-- number -->
							<v-text-field
                class="mt-4"
								v-if="field.input_type_id == 4"
								v-model="formData[field.id]"
								:label="field.name_field"
								:rules="field.required_field ? required : ''"
								variant="outlined"
                type="number"
                @keyup="(number) => {convertToNumber(formData[field.id], field.id)}"
                :hint="field.description" persistent-hint
              ></v-text-field>
							<!-- Image -->
						<v-file-input
              class="mt-4"
              v-if="field.input_type_id == 5"
              v-model="formData[field.id]"
              :label="field.name_field"
              variant="outlined"
              :clearable="false"
              accept="image/*"
              :rules="[requiredFile(field.id, field.required_field)]"
              @change="onChangeFile($event, field.id)"
              :hint="field.description" persistent-hint
            ></v-file-input>
            <!-- Phone -->
            <div class="mt-4" style="display:flex; align-items:center; gap: 8px;" v-if="field.input_type_id == 6">
                <span class="mb-4">+56</span>
            	<v-text-field
								v-model="formData[field.id]"
								:label="field.name_field"
								:rules="[phone(formData[field.id], field.required_field)]"
								variant="outlined"
                type="number"
                :hint="field.description" persistent-hint
              ></v-text-field>
            </div>
							<!-- date -->
<div class="mt-4" v-if="field.input_type_id === 7">
  <v-menu v-model="formFields[i].isMenuOpen">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :label="field.name_field"
        :value="moment(formData[field.id]).format('DD-MM-YYYY')"
        readonly
        v-bind="attrs"
        v-on="on"
        :hint="field.description"
        persistent-hint
      ></v-text-field>
    </template>
    <v-date-picker v-model="formData[field.id]"></v-date-picker>
  </v-menu>
</div>
              <!-- pdf -->
              <v-file-input
              class="mt-4"
              v-if="field.input_type_id == 8"
              v-model="formData[field.id]"
              :label="field.name_field"
              variant="outlined"
              @change="onChangeFile($event, field.id)"
              :rules="[requiredFile(field.id, field.required_field)]"
              accept="application/pdf"
              :hint="field.description" persistent-hint
            ></v-file-input>

            <!-- pdf & imagen -->
            <v-file-input
            class="mt-4"
              v-if="field.input_type_id == 9"
              v-model="formData[field.id]"
              :label="field.name_field"
              variant="outlined"
              @change="onChangeFile($event, field.id)"
              :rules="[requiredFile(field.id, field.required_field)]"
              accept="image/*,application/pdf"
              :hint="field.description" persistent-hint
            ></v-file-input>

              <!-- select -->
            <v-select class="mt-4" persistent-hint :hint="field.description" :rules="required" v-if="field.input_type_id == 10" v-model="formData[field.id]" :label="field.name_field" :items="field.options_select"></v-select>
						</div>
                    </v-col>
                    <v-col cols="12">
                      <v-row class="mt-2">
                        <v-col cols="12">
                          <v-btn :disabled="loadingbtn" :loading="loadingbtn" color="primary" @click="() => sendForm()">Reservar</v-btn>
                        </v-col>
                        <v-col cols="12">
                          <v-alert  v-if="errorMsg" variant="tonal" color="error" :text="errorMsg"></v-alert>
                          {{error}}
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
<!--                     <v-col cols="12" sm="12" md="6">
                      <v-text-field
                          v-model="patient.name"
                          :rules="nombreRules"
                          label="Nombre"
                          required
                          clearable
                          outlined
                          dense
                          class="inputForm"
                          :disabled="!isEditPatient"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-menu
                          ref="menuBirth"
                          v-model="menuBirth"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="patient.birthday"
                              label="Fecha de Nacimiento"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              class="inputForm"

                              dense
                              :disabled="!isEditPatient"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="patient.birthday"
                            :active-picker.sync="activePicker"
                            :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                            min="1940-01-01"
                            @change="saveDateBirth"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                          v-model="patient.phone"
                          :rules="telefonoRules"
                          label="Telefono"
                          required
                          clearable
                          class="inputForm"
                          outlined
                          dense
                          :disabled="!isEditPatient"
                          placeholder="Ej: 56912345678"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                          v-model="patient.email"
                          :rules="emailRules"
                          label="Email"
                          required
                          clearable
                          outlined
                          class="inputForm"
                          dense
                          :disabled="!isEditPatient"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                          v-model="patient.address"
                          :rules="direccionRules"
                          label="Direccion"
                          required
                          clearable
                          class="inputForm"
                          outlined
                          dense
                          :disabled="!isEditPatient"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="10" sm="6" md="5" class="justify-space-around align-center d-flex flex-row flex-wrap">
                      <v-btn
                          v-show="!isNewPatient"
                          color="primary"
                          class="white--text"
                          @click="isEditPatient = !isEditPatient"
                          outlined
                          rounded
                          block
                          :disabled="loading || !validRut"
                      >
                        <v-icon>mdi-square-edit-outline</v-icon>
                        Editar datos
                      </v-btn>
                    </v-col>
                    <v-col cols="10" sm="6" md="5" class="justify-space-around align-center d-flex flex-row flex-wrap">
                      <v-btn
                          color="primary"
                          class="white--text"
                          @click="() => {isEditPatient ? createPaciente() : nextStepSpecialty()}"
                          rounded
                          block
                          :disabled="!patient.name || !patient.birthday || !patient.phone || !patient.email || !patient.address || loading || !validRut"
                      >
                        Siguiente
                      </v-btn>
                    </v-col> -->
                  </v-col>
                </v-row>
<!--                step , seleccionar presencial o telemedicina -->
<!--                 <v-row
                    class="justify-center align-center"
                    v-if="step === 3"
                >
                  <v-col cols="12" sm="12" md="12" class="justify-center align-center d-flex flex-row flex-wrap">
                    <v-col cols="12" sm="6" md="6" class="justify-center align-center d-flex flex-row flex-wrap">
                      <v-btn
                          color="primary"
                          class="white--text"
                          @click="() => {nextStepTeleOrPresencial(false)}"
                          rounded
                          block
                      >
                        Presencial
                      </v-btn>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="justify-center align-center d-flex flex-row flex-wrap">
                      <v-btn
                          color="primary"
                          class="white--text"
                          @click="() => {nextStepTeleOrPresencial(true)}"
                          rounded
                          block
                      >
                        Telemática
                      </v-btn>
                    </v-col>
                  </v-col>
                </v-row> -->

                <!--              step , seleccionar especialidad-->
<!--                 <v-row class="justify-center align-center" v-if="step >= 4">
                  <v-col cols="12" sm="10" md="10">
                    <div
                        class="black--text font-weight-medium"
                    >
                      {{ patient.name }} | {{ patient.rut }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="10" md="10">
                    <v-row v-if="step === 4">
                      <hr class="hrForm">
                      <v-col cols="12" class="">
                        <v-row>
                          <div v-for="(item, i) in filteredSpecialities"
                               :key="i"
                               @click="() => {
                              !loading && selectSpeciality(item)}"
                               class="chips"
                               :style="{backgroundColor: item.color}">
                            {{ item.name }}
                          </div>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row> -->
                <hr v-if="step == 1">
                <!--    STEP 1        -->
                <v-row class="justify-center align-center" v-if="step == 1">

                  <v-col cols="12" sm="12" md="12">
                    <v-row v-if="step === 1" style="width: 100%" class="d-flex justify-center align-center">
                      <!--                      titulo para presencial-->
                      <v-col cols="12" md="12" class="d-flex justify-center align-center flex-row flex-wrap" v-if="flows.length > 0">
                        <v-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-center align-center" v-for="(item, i) in flows" :key="i">
                          <v-row class="d-flex justify-space-between align-center" v-if="item.user_type.form">
                            <v-col cols="12" md="5" class="d-flex align-center">
  <!--                             <div  class="rounded-xl justify-center align-center d-flex"
                                   style="width: 100px; height: 100px; background-color: #e0e0e0; overflow: hidden">
                             <v-img
                                  :src="item.avatar"
                                  width="100"
                                  height="100"
                                  v-if="item.avatar"
                                <v-icon v-else class="white--text" style="font-size: 80px">mdi-account</v-icon>
                              ></v-img> 
                              </div> -->

                              <div class="d-flex justify-center align-start flex-column mx-2">
                                <div
                                    style="word-break: break-word;"
                                    class="font-weight-medium black--text"
                                >
                                  {{ item.name }}
                                </div>
                                <div
                                    class="font-weight-medium black--text"
                                    style="word-break: break-word;">
                                  {{ item.description }}
                                </div>
                              </div>
                            </v-col>
<!--                             <v-col cols="12" md="4" class="d-flex justify-center align-center flex-column">
                              <div v-if="item.slots">
                                {{ formatDate(item.slots) }}
                              </div>
                              <v-btn
                                  color="blue"
                                  class="white--text mt-2"
                                  @click="() => {!loading && selectHour(item)}"
                                  rounded
                                  v-if="item.slots"
                              >
                                Seleccionar
                              </v-btn>
                            </v-col> -->
                            <v-col cols="3" class="d-flex justify-center align-center flex-column" style="margin: 0 auto;">
                              <v-btn
                                  color="blue"
                                  class="white--text"
                                  @click="() => {
                              !loading && selectFlow(item)}"
                                  outlined
                              >
                                <v-icon
                                    class="mr-2"
                                >mdi-calendar-month-outline
                                </v-icon>
                                {{item.reserv_hours ? 'Ver Agenda' : 'Reservar'}}
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <!--                v-if si no hay doctores disponibles para la especialidad-->
                <v-row v-if="step === 1 && flows.length === 0">
                  <v-col cols="12" class="d-flex justify-center align-center">
                    <span class="text-h6">
                      No hay atenciones disponibles
                    </span>
                  </v-col>
                </v-row>
                <!--              step 2, Seleccionar Hora-->
                <v-row class="d-flex justify-center align-center" v-if="step == 2">
                  <v-col cols="12" md="6" class="d-flex justify-center align-center flex-column">
                    <v-date-picker
                        v-model="selectedDate"
                        :min="selectedFlow.start_attentions ? selectedFlow.start_attentions : minDate"
                        :max="maxDate"
                        @change="getAvailableHours"
                        locale="es-cl"
                        :no-title="true"
                        :events="schedulesDays"
                        event-color="green lighten-1"
                    ></v-date-picker>
                  </v-col>
                  <v-col cols="12" md="6" class="d-flex justify-center align-center flex-column">
                    <div v-if="!festivos.includes(selectedDate) && moment(selectedDate).isSameOrAfter(moment(this.selectedFlow.start_attentions), 'day')">
                    <v-select
                        v-model="selectedEvent"
                        :items="availableHours"
                        :item-text="item => item.start"
                        :item-value="item => item"
                        :label="selectedEvent ? 'Hora Seleccionada' : 'Seleccione una hora'"

                        :rules="[v => !!v || 'Seleccione una hora']"
                        outlined
                        dense
                        :prepend-inner-icon="selectedEvent ? 'mdi-check' : 'mdi-clock-outline'"
                        @change="() => {logger(selectedEvent)}"
                        v-if="!loading && availableHours.length > 0"
                    ></v-select>
                    <small v-if="!selectedFlow.reserv_hours && !loading && availableHours.length" style="display:flex; justify-content: center;">Quedan {{quota}} Cupos.</small>
<!--                    texto que indica que no hay horas disponibles -->
                    <span v-if="!loading && availableHours.length === 0" class="text-h6">
                      No hay horas disponibles para esta fecha
                    </span>
                    <v-progress-circular
                        v-if="loading"
                        indeterminate
                        color="primary"
                        size="64"
                    ></v-progress-circular>
                    <v-btn
                        color="primary"
                        class="white--text"
                        @click="() => { !loading && takeHour()}"
                        :disabled="!selectedEvent || selectedEvent == {}"
                        v-if="!loading && availableHours.length"
                    >
                      Aceptar
                    </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="justify-center align-center" v-if="loading">
                  <v-col cols="12" sm="4" md="4" class="justify-center align-center">
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        class="mb-4"
                    ></v-progress-circular>
                  </v-col>
                </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="1"  md="2" lg="3">

        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import {validate, format} from 'rut.js';
import moment from "moment";
import {
  createAppointment,
  createQuotaAppointment,
  createPatient,
  getBookingSlotsBySpecialty,
/*   getListSpecialties, */
  getPatientByRut,
  getGeneralParams,
  sendWhatsapp,
  getFlows,
  getBookingSlotsByFlow,
  getQuota,
  getUserType,
  getFestivos
} from "@/helpers/api/horas_medicas";
import Swal from "sweetalert2";

export default {
  name: "Horas",
  data: () => {
    return {
      //////////
      flows: [],
      loadingbtn: false,

      /////////////////
      activePicker: null,
      date: null,
      dialogPaciente: false,
      isNewPatient: false,
      titleDialogPaciente: "Nuevo Usuario",
      isEditPatient: true,
      direccion: "",
      direccionRules: [
        v => !!v || "Direccion es requerido"
      ],
      doctor: "",
      doctores: [],
      doctoresTelemedicine: [],
      email: "",
      emailRules: [
        v => !!v || "Email es requerido",
        v => /.+@.+\..+/.test(v) || "Email debe ser valido"
      ],
      especialidad: "",
      especialidades: [],
      events: [],
      filteredDoctors: [],
      filteredDoctorsTelemedicine: [],
      filteredSpecialities: [],
      focus: '',
      from: null,
      horas: [],
      loading: false,
      menu: false,
      menuBirth: false,
      message: "",
      messageColor: "",
      nacimiento: "",
      nacimientoRules: [
        v => !!v || "Fecha de nacimiento es requerido"
      ],
      nombre: "",
      nombreRules: [
        v => !!v || "Nombre es requerido"
      ],
      page: 1,
      patient: {
        rut: "",
        name: "",
        email: "",
        birthday: "",
        address: "",
        phone: ""

      },
      availableHours: [],
      picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      rut: "",
      rutRules: [
        v => !!v || "Rut es requerido",
        v => validate(v) || "Rut no es valido"
      ],
      search: "",
      searchType: "",
      selectedElement: null,
      selectedEvent: null,
      selectedOpen: false,
      selectedHour: {},
      showMessage: false,
      selectedDate: null,
      step: 1,
      telefono: "",
      telefonoRules: [
        v => !!v || "Teléfono es requerido",
        v => /^569\d{8}$/.test(v) || "Teléfono no es valido"
      ],
      schedulesDays:  [],
      telemedicina: false,
      to: null,
      type: 'week',
      minDate: new Date().toISOString().substr(0, 10),
      maxDate: new Date(new Date().setMonth(new Date().getMonth() + 12)).toISOString().substr(0, 10),
      typeToLabel: {
        month: 'Mes',
        week: 'Semana',
        day: 'Dia',
        '4day': '4 Days',
      },
      valid: false,
      validRut: false,
      weekPage: 0,
      enable_telemedicine: null,
      wsp_enable: null,
      selectedFlow: null,
      formFields: [],
      formData: [],
      errorMsg: '',
      error: '',
      required: [
        v => !!v || 'Este campo es obligatorio'
      ],
      isEmailValid: [
    //eslint-disable-next-line
    v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Formato incorrecto'
  ],
	form: null,
  quota: null,
  festivos: [],
    }
  },
  computed: {
    moment() {
      return moment;
    },
  },
  mounted() {
    this.getFlows()
    this.getFestivos()
    this.from = moment().startOf('week').add(this.weekPage, 'week').format('YYYY-MM-DD')
    this.to = moment(this.from).add(30, 'days').format('YYYY-MM-DD')

  },
  watch: {
    menuBirth(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    step(val) {
        if (val === 1) {
        this.patient = {
        rut: "",
        name: "",
        email: "",
        birthday: "",
        address: "",
        phone: ""
      }
      }
    }
  },

  methods: {

    requiredFile(id, required) {
      if (required == 1 && (!this.formData[id] || this.formData[id] == {})) {
      return 'Este campo es obligatorio'
    }  else {
      return true
    }
  },
  phone(value, required) {
    if (required && !value) {
      return 'Este campo es obligatorio'
    }   
    else if (value && value.length > 9 || value && value.length < 9) {
      return 'La longitud del campo debe ser de 9 caracteres';
    }
    return true;
  },
  onChangeFile (e, id) {
      this.formData[id] = e.target.files['0']
  },
  convertToNumber (e, id) {
    this.formData[id] = Number(e);
  },
  formatRutD(rut, id) {
    let formattedValue = format(this.formData[id]);
    this.formData[id] = formattedValue;
  },
  setGeneralParams() {
    getGeneralParams().then((res) => {
          this.$store.commit("setGeneralParams", res);
          this.enable_telemedicine = res[1].value
          this.wsp_enable = res.filter(parameter => parameter.id == 3)[0].value
        });
    },

    randomColor() {
      const listColor = [
        "#c488d7",
        "#719acc",
        "#7b68d0",
        "#6fc16d",
        "#81c8ba"
      ]
      return listColor[Math.floor(Math.random() * listColor.length)]
    },
    switchTitle() {
      switch (this.step) {
        case 1:
          return "RESERVAR HORA";
        case 2:
          return "DATOS PERSONALES"
        case 4:
          return "SELECCIONAR UNA CATEGORIA"
        case 5:
          return "SELECCIONAR UNA CATEGORIA"
        case 6:
          return "SELECCIONAR FECHA Y HORA"
        default:
          return "RESERVAR HORA"
      }
    },
    switchIcon() {
      switch (this.step) {
        case 1:
          return "mdi-comment-text-multiple-outline"
        case 2:
          return "mdi-account"
        case 4:
          return "mdi-account-group"
        case 5:
          return "mdi-account-group"
        case 6:
          return "mdi-calendar-clock"
        default:
          return "mdi-comment-text-multiple-outline"
      }
    },
    validate,
    checkTelemedicine() {
      this.setGeneralParams()
    },
    saveDateBirth(date) {
      this.$refs.menuBirth.save(date)
    },
    cancelDialogPaciente() {
      this.dialogPaciente = false;
      this.isNewPatient = false;
      this.isEditPatient = false;
      this.titleDialogPaciente = "Nuevo Usuario";
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    createPaciente() {
      this.loading = true;
      let data = {
        rut: this.patient.rut,
        name: this.patient.name,
        email: this.patient.email,
        phone: this.patient.phone,
        address: this.patient.address,
        birthday: this.patient.birthday,
      };
      createPatient(data).then(async (response) => {
        this.loading = false;
        //this.patient = response
        if (this.isNewPatient) {
        await Swal.fire({
          title: 'Usuario creado',
          text: 'Usuario creado correctamente',
          icon: 'success',
          confirmButtonText: 'Aceptar'
        })
        } else if (!this.isNewPatient) {
            await Swal.fire({
              title: "Usuario Editado",
              text: "Usuario Editado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
          }
        await this.nextStepSpecialty();


      }).catch((error) => {
        this.loading = false;
        console.log(error);
      });

      this.loading = false;
    },
    async getEspecialidades() {
/*       this.loading = true;
      getListSpecialties().then((response) => {
        this.especialidades = response.especialidades.map((item) => {
          return {
            ...item,
            color: this.randomColor()
          }
        });
        this.filteredSpecialities = this.especialidades;
        this.loading = false;
      }).catch((error) => {
        console.log(error);
        this.loading = false;
      }) */
    },
    async getAvailableHours(e) {
      this.loading = true
      let horas = [];
      let events = [];
      this.availableHours = [];
      this.selectedEvent = null;
/*       let params = {
        doctor_id: this.doctor.id_doctor,
        specialty_id: this.especialidad.id,
        from: e,
        to: e,
        telemedicine: this.telemedicina
      } */
      const data = {flow_id: this.selectedFlow.id, day_search: moment(e).format('DD-MM-YYYY')}
      await getBookingSlotsByFlow(data).then(response => {
        if (this.selectedFlow.reserv_hours) {
          this.availableHours = response.data.map(hour => moment(hour.start, "HH:mm:ss").format('HH:mm'))
        } else {
          this.availableHours = response.data.length ? [response.data.map(hour => moment(hour.start, "HH:mm:ss").format('HH:mm'))[0]] : []
        }
        horas = response.availableSlots;
        horas.length > 0 && horas.forEach(item => {
          let dates = [];
          let from = moment(e);
          let to = moment(e);
          while (from.isSameOrBefore(to)) {
            dates.push(
                {
                  day: from.format("YYYY-MM-DD"),
                  dayNumber: from.format("d"),
                });
            from.add(1, 'days');
          }
          let date = dates.find(date => date.dayNumber === item.day);
          date && item.slots.forEach(slot => {

            let starts_at = moment(date.day + " " + slot, "YYYY-MM-DD HH:mm");
            let ends_at = moment(date.day + " " + slot, "YYYY-MM-DD HH:mm").add(15, 'minutes');
            if (starts_at.isAfter(moment())) {
              events.push({
                start: starts_at.format("YYYY-MM-DD HH:mm"),
                end: ends_at.format("YYYY-MM-DD HH:mm"),
                color: 'primary',
                timed: true,
                id_schedule: item.id_schedule,
                id_doctor: item.id_doctor,
                id_specialty: item.id_specialty,
                name: this.especialidad.name + " - " + (item.telemedicine ? "Telemática" : "Presencial"),
                details: `Categoría: ${this.especialidad.name} - Horario: ${moment(starts_at).format("HH:mm")} - ${moment(ends_at).format("HH:mm")}`,
                telemedicine: item.telemedicine
              })
            }
          })
        })
       
          let dates = [];
          let eventsDates = [];
          let from = moment().add(1, 'days');
          let to = moment().add(30, 'days');
          while (from.isBefore(to)) {
            dates.push(
                {
                  day: from.format("YYYY-MM-DD"),
                  dayNumber: from.format("d"),
                });
            from.add(1, 'days');
          }
          // filter dates with schedulesDays
          dates = dates.filter(date => response.schedulesDays.some(schedule => schedule === date.dayNumber))
          dates.forEach(day => {
            let starts_at = moment(day.day , "YYYY-MM-DD");
            if (starts_at.isAfter(moment())) {
              eventsDates.push(starts_at.format("YYYY-MM-DD"))
            }
          })
          this.schedulesDays = eventsDates.filter(item => !this.festivos.includes(item));
        
        this.loading = false
      }).catch(error => {
        this.loading = false
        console.log(error)
      })

      if (!this.selectedFlow.reserv_hours) {
        const dataa = {flow_id: this.selectedFlow.id, date_reservation: moment(e).format('YYYY-MM-DD')}
        getQuota(dataa).then(res => {
          this.quota = res.data.available
        })
      }
    },




    async getHorarios(dif) {
      this.loading = true;
      let events = [];
      let horas = [];
      let color = 'primary';
      this.weekPage = this.weekPage + dif;

      let data = {
        specialty_id: this.especialidad.id,
        from: moment().startOf('week').add(this.weekPage, 'week').format('YYYY-MM-DD'),
        to: moment().endOf('week').add(this.weekPage, 'week').format('YYYY-MM-DD'),
        doctor_id: this.doctor.id_doctor,
        telemedicine: this.telemedicina
      }

      await getBookingSlotsByFlow(data).then(response => {
        horas = response.availableSlots;
        horas.forEach(item => {
          let dates = [];
          let from = moment(data.from);
          let to = moment(data.to);
          while (from.isBefore(to)) {
            dates.push(
                {
                  day: from.format("YYYY-MM-DD"),
                  dayNumber: from.format("d"),
                });
            from.add(1, 'days');
          }
          item.slots.forEach(slot => {
            let date = dates.find(date => date.dayNumber === item.day);
            let starts_at = moment(date.day + " " + slot, "YYYY-MM-DD HH:mm");
            let ends_at = moment(date.day + " " + slot, "YYYY-MM-DD HH:mm").add(15, 'minutes');
            if (starts_at.isAfter(moment())) {
              events.push({
                start: starts_at.format("YYYY-MM-DD HH:mm"),
                end: ends_at.format("YYYY-MM-DD HH:mm"),
                color: color,
                timed: true,
                id_schedule: item.id_schedule,
                id_doctor: item.id_doctor,
                id_specialty: item.id_specialty,
                name: this.especialidad.name + " - " + (item.telemedicine ? "Telemática" : "Presencial"),
                details: `Categoría: ${this.especialidad.name} - Horario: ${moment(starts_at).format("HH:mm")} - ${moment(ends_at).format("HH:mm")}`,
                telemedicine: item.telemedicine
              })
            }
          })
        })
        this.events = events;
        this.loading = false;
      }).catch(error => {
        console.log(error);
        this.loading = false;
      })
    },
    updateRange({start, end}) {
      //this.getHorarios()
    },
    logger(e) {
      console.log(e)
    },
    showEvent({nativeEvent, event}) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    viewDay({date}) {
      this.focus = date
      this.type = 'day'
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    getEventColor(event) {
      return event.color
    },
    setToday() {
      this.focus = ''
    },
    async prev() {
      if (this.weekPage > 0) {
        this.loading = true;
        await this.getHorarios(-1);
        this.loading = false;
        this.$refs.calendar.prev()
      }
    },
    async next() {
      this.loading = true;
      await this.getHorarios(1);
      this.loading = false;
      this.$refs.calendar.next()
    },

    formatDate(slots) {
      let day = moment().format('d')
      if (slots.day < day) {
        return `${moment().add(1, 'week').day(slots.day).locale('es').format('DD-MM-YYYY')} / ${slots.slot}`
        // moment().add(1, 'week').day(slots.day).locale('es').format('dddd DD-MM-YYYY') + '/' + slots.slot
      } else {
        return `${moment().add(1, 'day').day(slots.day).locale('es').format('DD-MM-YYYY')} / ${slots.slot}`
        // moment().add(1, 'day').day(slots.day).locale('es').format('dddd DD-MM-YYYY') + '/' + slots.slot
      }
    },
    clearRut() {
      this.patient.rut = "";
      this.validRut = false;
      this.step = 1;
    },
    formatRut(rut) {
      this.patient.rut = format(rut)
      this.validRut = validate(this.patient.rut)
    },
    clearSpeciality() {
      this.especialidad = "";
      this.step = 2;
    },
    clearDoctor() {
      this.doctor = "";
      this.step = 3;
    },
    async searchRut() {
      this.loading = true;
      await getPatientByRut(this.patient.rut)
          .then(response => {
            this.loading = false;
            if (response.id) {
              this.patient = response;
              this.isEditPatient = false;
              this.isNewPatient = false;
              this.step = 2;
            } else {
              this.isNewPatient = true;
              this.isEditPatient = true;
              this.step = 2;
            }

          })
          .catch(error => {
            console.log(error);
            this.loading = false;
          });
    },

    async nextStepSpecialty() {
      await this.checkTelemedicine();
      if(this.enable_telemedicine == 1){
        this.step = 3;
      }else{
        await this.getEspecialidades();
        this.step = 4;
      }
    },
    nextStep() {
      this.step++;
    },
    async nextStepTeleOrPresencial(e) {
      this.telemedicina = e;
      await this.getEspecialidades();
      this.step = 4;
    },

    async selectSpeciality(item) {
      this.especialidad = item;
      if(this.especialidad.name === "Defensoria a tu casa"){
        await Swal.fire({
          title: 'Requisitos para Defensoria a tu casa',
          html: '<ul><li>1.- Ser adulto mayor</li>' +
              '<li>2.- Encontrarse en situación de discapacidad</li>' +
              '<li>3.- Movilidad reducida</li>' +
              '<li>4.- Tratarse de consulta jurídica o legal</li>' +
              '*Requisitos no copulativos. Es suficiente uno de ellos.' +
              '</ul>',
          icon: 'info',
          confirmButtonText: 'Aceptar'
        })
      }
      this.search = "";
      this.loading = true;
      let data = {
        from: moment().format('YYYY-MM-DD') + 'T' + moment().format('HH:mm:ss'),
        to: moment().add(7, 'days').format("YYYY-MM-DD") + 'T23:59:59',
        specialty_id: this.especialidad.id,
        telemedicine: this.telemedicina
      }
      await getBookingSlotsBySpecialty(data).then(response => {
        this.doctores = response.data;
        this.filteredDoctors = response.data;
        this.loading = false;
        this.nextStep();
      }).catch(error => {
        console.log(error);
        this.loading = false;
      });
      // if (this.enable_telemedicine) {
      //   data.telemedicine = true;
      //   await getBookingSlotsBySpecialty(data).then(response => {
      //     this.doctoresTelemedicine = response.data;
      //     this.filteredDoctorsTelemedicine = response.data;
      //     this.loading = false;
      //   }).catch(error => {
      //     console.log(error);
      //     this.loading = false;
      //   });
      // }
    },
    obtainDoctors(horas) {
      let doctors = [];
      horas.forEach(item => {
        //  verificar si el doctor ya está en el array
        let doctor = doctors.find(doctor => doctor.id === item.resources[0].id);
        if (!doctor) {
          doctors.push({
            id: item.resources[0].id,
            name: item.resources[0].name,
            starts_at: item.starts_at,
            ends_at: item.ends_at,
          })
        }
        //  si esta, verificar la hora de inicio es menor a la hora de inicio del doctor
        else {
          let doctorIndex = doctors.findIndex(doctor => doctor.id === item.resources[0].id);
          let doctorStart = moment(doctor.starts_at).format("HH:mm");
          let itemStart = moment(item.starts_at).format("HH:mm");
          if (doctorStart > itemStart) {
            doctors[doctorIndex].starts_at = item.starts_at;
          }
        }
      })
      this.doctores = doctors;
      this.filteredDoctors = this.doctores;
      this.nextStep();
    }
    ,
    async selectFlow(flow) {
      this.step = 2;
      this.selectedFlow = flow

        const orderedArr = flow.user_type.form.inputs_form.sort((a, b) => a.position - b.position);

				this.formFields = orderedArr.map(field => {
          field.isMenuOpen = false
          return field
        })
				this.formData = orderedArr.reduce((acc, item) => {
          if (item.input_type_id == 7) {
            acc[item.id] = moment().format('YYYY-MM-DD');
          }
            else if (item.input_type_id == 5 || item.input_type_id == 8) {
              acc[item.id] = null
          } else {
  					acc[item.id] = '';
          }
 					return acc;
			}, {});

      this.formFields = orderedArr




      this.focus = "";
      this.weekPage = 0;
      this.search = ""
      this.loading = true;
      this.schedulesDays = []; 
      this.availableHours = [];
      let events = [];
      let color = 'primary';
/*       let data = {
        specialty_id: this.especialidad.id,
        from: moment().format("YYYY-MM-DD"),
        to: moment().format("YYYY-MM-DD"),
        doctor_id: this.doctor.id_doctor,
        telemedicine: this.telemedicina
      } */

/*     const data = {flow_id: flow.id, day_search: moment().format('DD-MM-YYYY')} */
    const data = {flow_id: flow.id, day_search: moment().format('DD-MM-YYYY') }
      await getBookingSlotsByFlow(data).then(response => {
        if (this.selectedFlow.reserv_hours) {
          this.availableHours = response.data.map(hour => moment(hour.start, "HH:mm:ss").format('HH:mm'))
        } else {
          this.availableHours = [response.data.map(hour => moment(hour.start, "HH:mm:ss").format('HH:mm'))[0]]
          this.selectedDate = moment().format('YYYY-MM-DD')
          this.selectedEvent = this.availableHours[0]
        }
      let currentDate = moment();
      let availableDays = this.selectedFlow.flow_configuration.attention_days.map(flow => {
        return flow.day_of_week
      })
      availableDays = availableDays.map(day => this.numberDay(day))

      while (currentDate.isBefore(moment().add(365, 'days'))) { 
        if (availableDays.includes(currentDate.day())) {
          this.schedulesDays.push(currentDate.format('YYYY-MM-DD'));
        }
        currentDate.add(1, 'days');
      }
      this.schedulesDays = this.schedulesDays.filter(item => !this.festivos.includes(item));
      this.loading = false;


/*         response.availableSlots.length > 0 &&  response.availableSlots.forEach(item => {
          let dates = [];
          let from = moment(data.from);
          let to = moment(data.to);
          while (from.isBefore(to)) {
            dates.push(
                {
                  day: from.format("YYYY-MM-DD"),
                  dayNumber: from.format("d"),
                });
            from.add(1, 'days');
          }
          item.slots.forEach(slot => {
            let date = dates.filter(date => date.dayNumber === item.day);
            let starts_at = moment(date.day + " " + slot, "YYYY-MM-DD HH:mm");
            let ends_at = moment(date.day + " " + slot, "YYYY-MM-DD HH:mm").add(15, 'minutes');
            if (starts_at.isAfter(moment())) {
              events.push({
                start: starts_at.format("YYYY-MM-DD HH:mm"),
                end: ends_at.format("YYYY-MM-DD HH:mm"),
                color: color,
                timed: true,
                id_schedule: item.id_schedule,
                id_doctor: item.id_doctor,
                id_specialty: item.id_specialty,
                name: this.especialidad.name,
                details: `Categoría: ${this.especialidad.name} - Horario: ${moment(starts_at).format("HH:mm")} - ${moment(ends_at).format("HH:mm")}`,
                telemedicine: this.telemedicina
              })
            }
          })
        })
        if(response.schedulesDays && response.schedulesDays.length > 0){
          let dates = [];
          let eventsDates = [];
          let from = moment().add(1, 'days');
          let to = moment().add(30, 'days');
          while (from.isBefore(to)) {
            dates.push(
                {
                  day: from.format("YYYY-MM-DD"),
                  dayNumber: from.format("d"),
                });
            from.add(1, 'days');
          }
          dates = dates.filter(date => response.schedulesDays.some(schedule => schedule === date.dayNumber))
          dates.forEach(day => {
            let starts_at = moment(day.day , "YYYY-MM-DD");
            if (starts_at.isAfter(moment())) {
              eventsDates.push(starts_at.format("YYYY-MM-DD"))
            }
          })
          this.schedulesDays = eventsDates
        }
        if (events.length > 0) {
          this.availableHours = events;
        }
        this.loading = false;
        this.nextStep(); */
      }).catch(error => {
        console.log(error);
        this.loading = false;
      });

        if (!this.selectedFlow.reserv_hours) {
        const dataa = {flow_id: this.selectedFlow.id, date_reservation: moment().format('YYYY-MM-DD')}
        getQuota(dataa).then(res => {
          this.quota = res.data.available
        })
      }
    }
    ,
    searchEspecialidad() {
      this.filteredSpecialities = this.especialidades.filter((item) => {
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
    ,
    selectHour(item) {
      let day = moment().format('d')
      let date = null;
      if (item.slots.day < day) {
        date = moment().add(1, 'week').day(item.slots.day).format('YYYY-MM-DD')
      } else {
        date = moment().add(1, 'day').day(item.slots.day).format('YYYY-MM-DD')
      }
      let data = {
        id_patient: this.patient.id,
        id_doctor: item.slots.doctor_id,
        id_specialty: item.slots.specialty_id,
        id_schedule: item.slots.id,
        start_time: item.slots.slot,
        end_time: moment(item.slots.slot, "HH:mm").add(15, 'minutes').format("HH:mm"),
        date: date,
        telemedicine: this.telemedicina
      }
      if (item.reserv_hours) {
        createAppointment(data).then(async response => {
          /*         sendWhatsapp(data).then(res => {
        console.log(res);
      }) */
        await Swal.fire({
          title: 'Cita creada',
          text: `Los datos de la reserva han sido enviados a su correo ${this.wsp_enable == "1" ? 'y Whatsapp.' : ''}`,
          icon: 'success',
          confirmButtonText: 'Aceptar',
        }).then(result => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        })
      }).catch(async error => {
        console.log(error);
        await Swal.fire({
          title: 'Error',
          text: error.response.data.message || 'Ha ocurrido un error al crear la cita',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
      })
    }
    else {
      createQuotaAppointment(data).then(async response => {
          /*         sendWhatsapp(data).then(res => {
        console.log(res);
      }) */
        await Swal.fire({
          title: 'Cita creada',
          text: `Los datos de la reserva han sido enviados a su correo ${this.wsp_enable == "1" ? 'y Whatsapp.' : ''}`,
          icon: 'success',
          confirmButtonText: 'Aceptar',
        }).then(result => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        })
      }).catch(async error => {
        console.log(error);
        await Swal.fire({
          title: 'Error',
          text: error.response.data.message || 'Ha ocurrido un error al crear la cita',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
      })
    }
    }
    ,
    selectHourTelemedicine(item) {
      console.log(item);
    }
    ,
    searchDoctor() {
      this.filteredDoctors = this.doctores.filter((item) => {
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      });
      this.filteredDoctorsTelemedicine = this.doctoresTelemedicine.filter((item) => {
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
    ,
    subsStep() {
      this.step--;
      if(this.step === 3 && this.enable_telemedicine == 0){
        this.step--;
      }
    },
    takeHour() {
      this.loading = true;
      setTimeout(() => {
        this.step = 3
        this.loading = false;
      }, 1000);
/*       let data = {
        id_patient: this.patient.id,
        id_doctor: this.selectedEvent.id_doctor,
        id_specialty: this.selectedEvent.id_specialty,
        id_schedule: this.selectedEvent.id_schedule,
        start_time: moment(this.selectedEvent.start).format("HH:mm"),
        end_time: moment(this.selectedEvent.end).format("HH:mm"),
        date: moment(this.selectedEvent.start).format("YYYY-MM-DD"),
        telemedicine: this.selectedEvent.telemedicine
      }
      createAppointment(data).then(async response => { */
/*         sendWhatsapp(data).then(res => {
          console.log(res);
        }) */
/*         await Swal.fire({
          title: 'Cita creada',
          text: `Los datos de la reserva han sido enviados a su correo ${this.wsp_enable == "1" ? 'y Whatsapp.' : ''}`,
          icon: 'success',
          confirmButtonText: 'Aceptar',
        }).then(result => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        })
      }).catch(async error => {
        console.log(error);
        await Swal.fire({
          title: 'Error',
          text: error.response.data.msg || 'Ha ocurrido un error al crear la cita',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
      }) */
    },
    getFlows() {
      getFlows({area_id: this.$store.state.area_id}).then(res => {
        this.flows = res.data
        
      })
    },
    async sendForm() {
if(this.$refs.form.validate()){
      this.loadingbtn = true
      const date =  moment(this.selectedDate)
      const hour = moment(this.selectedEvent, "HH:mm");
      var dateTimeObj = date.set({
        hour: hour.get('hour'),
        minute: hour.get('minute')
      });
      const attention_start =  dateTimeObj.format("DD-MM-YYYY HH:mm");
      

  const formInputs = {...this.formData}

// add +56 phone fields
Object.keys(formInputs).forEach(key => {
  this.formFields.forEach(item => {
    if (item.id == key && item.input_type_id === 6) {
        formInputs[item.id] = '+56' + formInputs[item.id]
    }
    // format date
    if (item.id == key && item.input_type_id === 7) {
        formInputs[item.id] = moment(formInputs[item.id]).format('DD-MM-YYYY')
    }
  });
});

      const obj = {
        ...formInputs,
        attention_type: this.selectedFlow.attention_type_id,
        flow_id: this.selectedFlow.id,
        client_id: this.$store.state.userData.id,
        attention_start
    }
    if (!this.selectedFlow.reserv_hours) {
      obj.date_reservation = moment(this.selectedDate).format('YYYY-MM-DD')
      obj.hour_reservation = moment(hour).format('HH:mm')
      delete obj.attention_start
    }
    let data = new FormData();
      for (const property in obj) {
        data.append(property, obj[property]);
      }

    if (this.selectedFlow.reserv_hours) {
    createAppointment(data).then(res => {
/*       if (this.$store.state.area_id !== 1 && this.$store.state.area_id !== 4) { */
      this.loadingbtn = false
      this.step = 1;
      Swal.fire({
          title: 'Cita creada',
          text: `Los datos de la reserva han sido enviados a su correo`,
          icon: 'success',
          confirmButtonText: 'Aceptar',
        }).then(result => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        })
/*          } else { */
/*         localStorage.setItem('pending-reserv', JSON.stringify(data)) */
/*         window.location.href = res.url;
      } */
      }).catch(async error => {
        this.loadingbtn = false
        console.log(error);
        Swal.fire({
          title: 'Error',
          text: error.response.data.msg || 'Ha ocurrido un error al crear la cita',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
      })
    }
    else {
      createQuotaAppointment(data).then(async response => {
/*       if (this.$store.state.area_id !== 1 && this.$store.state.area_id !== 4) {  */
      this.loadingbtn = false
      this.step = 1;
        await Swal.fire({
          title: 'Cita creada',
          text: `Los datos de la reserva han sido enviados a su correo ${this.wsp_enable == "1" ? 'y Whatsapp.' : ''}`,
          icon: 'success',
          confirmButtonText: 'Aceptar',
        }).then(result => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        })
/*       }
      else {
        window.location.href = response.url;
      } */
      }).catch(async error => {
        this.loadingbtn = false
        console.log(error);
        await Swal.fire({
          title: 'Error',
          text: error.response.data.message || 'Ha ocurrido un error al crear la cita',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
      })
    }


      }
    },
    numberDay(day) {
      const days = {
        LUNES: 1,
        MARTES: 2,
        MIERCOLES: 3,
        JUEVES: 4,
        VIERNES: 5,
        SABADO: 6,
      }
      return days[day]
    },
    getFestivos() {
      getFestivos().then(res => {
        this.festivos = res.data.map(festivo => festivo.fecha)
        
      })
    },
  }
}
</script>

<style scoped>
.inputForm {
  border-radius: 10px !important;
}

.chips {
  border-radius: 20px !important;
  color: white;
  margin: 10px;
  padding: 5px 30px;
  cursor: pointer;
}

.hrForm {
  margin: 10px 0;
  width: 100%;

}
.gradientBackground {
  background: #003153;
  overflow-y: auto;
  height: 100%;
}

.card-title {
  font-size: .8rem ;
}

  @media (min-width: 475px) {
    .card-title {
      font-size: 1rem ;
    }
} 

.card-reserva {
  margin-top: 80px;
}
@media (min-width: 475px) {
  .card-reserva {
    margin-top: 0;
  }
}
.subtitle {
  font-size: 12px;
}
  @media (min-width: 475px) {
    .subtitle {
      font-size: 16px;
    }
}


.datos-personales {
  margin-top:70px;
}
@media (min-width: 475px) {
  .datos-personales {
    margin-top: 0;
  }
}



</style>
